import { API_BASE_URL, getHeaders, handleResponse } from '../apiConfig';

export const fetchStaff = async (params = {}) => {
  const query = new URLSearchParams();
  if (params && typeof params === 'object') {
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        query.append(key, params[key]);
      }
    });
  }
  const queryString = query.toString() ? `?${query.toString()}` : '';
  const response = await fetch(`${API_BASE_URL}/staff${queryString}`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const createStaff = async (data) => {
  const response = await fetch(`${API_BASE_URL}/staff`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const updateStaff = async (id, data) => {
  const response = await fetch(`${API_BASE_URL}/staff/${id}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const deleteStaff = async (id) => {
  const response = await fetch(`${API_BASE_URL}/staff/${id}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return handleResponse(response);
};
